// import React from "react";
// import "./OurJourney.css";
// import parse from "html-react-parser";
// import { Container, Row, Col } from "react-bootstrap";
// import Banner_vdo from "../banner_vdo/Banner_vdo";

// const OurJourney = ({ about_us }) => {
//   return (
//     <div className="about-section container">
//   <Container fluid>

//       <div className="video-float">
//         <Banner_vdo about_us={about_us} />
//       </div>

//       <h2 className="about-title">About Us</h2>

//       <div className="about-text">
//         {typeof about_us?.content === "string"
//           ? parse(about_us.content)
//           : "No content available."}
//       </div>

//   </Container>
//     </div>
//   );
// };

// export default OurJourney;

import React from "react";
import "./OurJourney.css";
import parse from "html-react-parser";
import { Container } from "react-bootstrap";
import Banner_vdo from "../banner_vdo/Banner_vdo";

const OurJourney = ({ about_us }) => {
  // Video uploaded from admin panel
  const hasVideo = Boolean(about_us?.video);

  return (
    <div className={`about-section ${!hasVideo ? "no-video" : ""}`}>
      <Container fluid>

        {/* Video will render only when uploaded */}
        {hasVideo && (
          <div className="video-float">
            <Banner_vdo about_us={about_us} />
          </div>
        )}

        <h2 className="about-title">About Us</h2>

        <div className="about-text">
          {typeof about_us?.content === "string"
            ? parse(about_us.content)
            : "No content available."}
        </div>

      </Container>
    </div>
  );
};

export default OurJourney;